import React from 'react';

interface IProps {
  className?: string;
}

const CloseIcon = ({ className = '' }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="#fff"
      viewBox="0 0 32 32"
      fillRule="evenodd"
      className={className}
    >
      <path d="M18.1 16l8.9 8.88L24.9 27 16 18.1 7.1 27 5 24.88 13.9 16 5 7.1 7.1 5l8.9 8.9L24.9 5 27 7.1z" />
    </svg>
  );
};

export default CloseIcon;
